import "./Contact.scss";
import { Helmet } from 'react-helmet';
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import InputField from "../../components/InputField/InputField";
import Button from "../../components/Button/Button";
import MessageField from "../../components/MessageField/MessageField";
import useWeb3forms from "@web3forms/react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Notification from "../../components/Notification/Notification"

function Contact() {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
      } = useForm();
    
      const [result, setResult] = useState(null);
      const [isSuccess, setIsSuccess] = useState(false);
    
      const accessKey = "e9b67721-3429-4ee9-9893-a0a4c41118bd";
    
      const { submit: onSubmit } = useWeb3forms({
        access_key: accessKey,
        settings: {
          from_name: "Sony Chen",
          subject: "New Contact Message",
        },
        onSuccess: (msg, data) => {
          setIsSuccess(true);
          setResult(msg);
          reset();
        },
        onError: (msg, data) => {
          setIsSuccess(false);
          setResult(msg);
        },
      });
    

  return (
    <div className="page-layout">
      <Helmet>
        <title>Contact me - Sony Chen</title>
      </Helmet>

      <Header />
      <main className="page-layout-main">
        <section className="page-layout-main__project-section">
            <div className="page-layout-main__form-section-wrapper">
                <div className="page-layout-main__header-container">
                    <h1 className="page-layout-main__header">Let's get in touch!</h1>
                    <p className="page-layout-main__body">Want to chat about boba, games, or brainstorm exciting design ideas? Let’s connect!</p>
                </div>
                <form className="form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="form__input-container">
                        <div className="form__upper-section">
                            <InputField
                                type="text"
                                label="Name*"
                                name="name"
                                {...register ("name", {required: "Name is required"})}
                                error={errors.name?.message}
                            />

                            <InputField
                                type="text"
                                label="Email*"
                                name="email"
                                {...register ("email", {required: "Email is required"})}
                                error={errors.email?.message}
                            />
                        </div>

                        <MessageField
                            label="Message*"
                            {...register("message", { required: "Message is required" })}
                            error={errors.message?.message}
                        />
                    </div>

                    <div className="form__button">
                        <Button 
                            isLink={false}
                            type="primary"
                            buttonSize="56px"
                            buttonType="submit"
                            text="Send"
                            ariaLabel="Submit contact form"
                        />
                    </div>

                    {result && (
                        <Notification 
                            layout={isSuccess ? "success" : "error"}
                            text={result}
                        />
                    )}
                </form>
            </div>
        </ section>
        <Footer noBackgroundColor="true" />
      </main>
    </div>
  );
}

export default Contact;
